import { defineStore } from "pinia";
import { ref } from "vue";
import { Pagination } from "@/interfaces/paginatedResponse.ts";
import { PendingRequest, NewDataUser } from "@/modules/pendingRequests/interfaces/pendingRequest.ts";

export const useUserApprovalsStore = defineStore("userApprovals", () => {
  const pagination = ref<{ [key: string]: Pagination }>({});
  const users = ref<{ [key: string]: PendingRequest<NewDataUser>[] }>({});

  const pages = ref<{ [key: string]: number }>({
    pending: 1,
    approved: 1,
    rejected: 1,
  });

  return {
    pagination,
    users,
    pages,

    setUsers(type: string, newUsers: PendingRequest<NewDataUser>[]) {
      users.value[type] = newUsers;
    },

    setPagination(type: string, newMeta: Pagination) {
      pagination.value[type] = newMeta;
    },

    setPage(type: string, newPage: number) {
      pages.value[type] = newPage;
    },
  };
});
